/* =========================================================
   INARA — storefront behavior
   ========================================================= */
(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function on(el, evt, fn) { if (el) el.addEventListener(evt, fn); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return (cents / 100).toFixed(2) + (format ? ' ' + format : '');
  }

  /* ---------- Overlay/drawer open-close with focus + scroll lock ---------- */
  var lastFocused = null;

  function lockScroll(locked) {
    document.body.style.overflow = locked ? 'hidden' : '';
  }

  function openPanel(el) {
    if (!el) return;
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    lockScroll(true);
    var focusable = el.querySelector('input, button, a[href]');
    if (focusable) focusable.focus();
  }

  function closePanel(el) {
    if (!el) return;
    el.classList.remove('is-open');
    if (!document.querySelector('.is-open')) lockScroll(false);
    if (lastFocused) lastFocused.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.is-open').forEach(closePanel);
  });

  /* ---------- Mobile nav ---------- */
  var mobileNav = $('[data-mobile-nav]');
  on($('[data-mobile-nav-open]'), 'click', function () { openPanel(mobileNav); });
  $$('[data-mobile-nav-close]').forEach(function (btn) {
    on(btn, 'click', function () { closePanel(mobileNav); });
  });

  /* ---------- Header scroll state ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Cart ---------- */
  var cartDrawer = $('[data-cart-drawer]');
  var cartIsDrawer = document.body.dataset.cartType !== 'page';

  on($('[data-cart-open]'), 'click', function (e) {
    if (!cartIsDrawer) return;
    e.preventDefault();
    openPanel(cartDrawer);
  });
  $$('[data-cart-close]').forEach(function (btn) {
    on(btn, 'click', function () { closePanel(cartDrawer); });
  });

  function refreshCartDrawer() {
    return fetch(routes + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer]');
        if (fresh && cartDrawer) {
          var wasOpen = cartDrawer.classList.contains('is-open');
          cartDrawer.innerHTML = fresh.innerHTML;
          if (wasOpen) cartDrawer.classList.add('is-open');
          bindCartLines();
        }
      })
      .catch(function () { /* leave existing markup in place */ });
  }

  function updateCartCount(count) {
    var badge = $('[data-cart-count]');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? '' : 'none';
    }
  }

  function changeLine(key, quantity) {
    return fetch(routes + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshCartDrawer();
      });
  }

  function bindCartLines() {
    $$('[data-cart-line]').forEach(function (line) {
      var key = line.dataset.lineKey;
      var input = $('[data-cart-qty-input]', line);

      on($('[data-cart-qty-decrease]', line), 'click', function () {
        changeLine(key, Math.max(0, parseInt(input.value, 10) - 1));
      });
      on($('[data-cart-qty-increase]', line), 'click', function () {
        changeLine(key, parseInt(input.value, 10) + 1);
      });
      on(input, 'change', function () {
        changeLine(key, Math.max(0, parseInt(input.value, 10) || 0));
      });
      on($('[data-cart-remove]', line), 'click', function () {
        changeLine(key, 0);
      });
    });
  }
  bindCartLines();

  /* Engraving character counter */
  $$('[data-engraving-input]').forEach(function (input) {
    var counter = $('[data-engraving-counter]', input.closest('.engraving'));
    var max = input.getAttribute('data-engraving-max') || input.maxLength;
    function sync() {
      if (counter) counter.textContent = input.value.length + ' / ' + max;
    }
    on(input, 'input', sync);
    sync();
  });

  /* Add to cart via any product form */
  $$('[data-product-form]').forEach(function (form) {
    on(form, 'submit', function (e) {
      e.preventDefault();
      var button = $('[data-add-to-cart]', form);
      if (button) button.classList.add('is-disabled');

      /* An empty engraving field would still post a blank line-item
         property, so drop it from the payload rather than send noise. */
      var engraving = $('[data-engraving-input]', form);
      var engravingWasDisabled = false;
      if (engraving && engraving.value.trim() === '') {
        engraving.disabled = true;
        engravingWasDisabled = true;
      }

      var payload = new FormData(form);
      if (engravingWasDisabled) engraving.disabled = false;

      fetch(routes + 'cart/add.js', {
        method: 'POST',
        body: payload
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch(routes + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          return refreshCartDrawer();
        })
        .then(function () {
          if (cartIsDrawer) openPanel(cartDrawer);
          else window.location.href = routes + 'cart';
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (button) button.classList.remove('is-disabled');
        });
    });
  });

  /* ---------- Predictive search ---------- */
  var searchOverlay = $('[data-search-overlay]');
  var searchInput = $('[data-search-input]');
  var searchResults = $('[data-search-results]');

  on($('[data-search-open]'), 'click', function () { openPanel(searchOverlay); });
  $$('[data-search-close]').forEach(function (btn) {
    on(btn, 'click', function () { closePanel(searchOverlay); });
  });

  var searchTimer;
  on(searchInput, 'input', function () {
    var q = searchInput.value.trim();
    clearTimeout(searchTimer);

    if (q.length < 2) {
      searchResults.innerHTML = '';
      return;
    }

    searchTimer = setTimeout(function () {
      fetch(routes + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            searchResults.innerHTML = '<p class="text-muted">No pieces found.</p>';
            return;
          }
          var cards = products.map(function (p) {
            var img = p.featured_image && p.featured_image.url
              ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy" style="width:100%;aspect-ratio:4/5;object-fit:cover;">'
              : '<div style="width:100%;aspect-ratio:4/5;background:var(--color-bg-alt);"></div>';
            return '<a href="' + p.url + '" class="product-card">' +
              '<div class="product-card__media">' + img + '</div>' +
              '<div class="product-card__body">' +
                '<h3 class="product-card__title">' + p.title + '</h3>' +
                '<p class="product-card__price">' + (p.price ? formatMoney(p.price) : '') + '</p>' +
              '</div></a>';
          }).join('');
          searchResults.innerHTML =
            '<p class="search-overlay__group-label">Pieces</p>' +
            '<div class="product-grid">' + cards + '</div>';
        })
        .catch(function () {
          searchResults.innerHTML = '';
        });
    }, 250);
  });

  /* ---------- Product page: gallery + variants ---------- */
  var productSection = $('[data-product-section]');
  if (productSection) {
    var variantsScript = $('[data-variants-json]', productSection);
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var variantIdInput = $('[data-variant-id]', productSection);
    var priceEl = $('[data-product-price]', productSection);
    var addButton = $('[data-add-to-cart]', productSection);

    function selectedOptions() {
      return $$('[data-option-index]', productSection)
        .filter(function (el) { return el.classList.contains('is-selected'); })
        .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
        .map(function (el) { return el.dataset.optionValue; });
    }

    function matchVariant() {
      var chosen = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
    }

    function applyVariant() {
      var variant = matchVariant();
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available
          ? addButton.dataset.labelAvailable
          : addButton.dataset.labelSoldOut;
      }

      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    $$('[data-option-value]', productSection).forEach(function (swatch) {
      on(swatch, 'click', function () {
        var index = swatch.dataset.optionIndex;
        $$('[data-option-index="' + index + '"]', productSection).forEach(function (s) {
          s.classList.remove('is-selected');
        });
        swatch.classList.add('is-selected');
        var label = $('[data-option-selected-label="' + index + '"]', productSection);
        if (label) label.textContent = swatch.dataset.optionValue;
        applyVariant();
      });
    });

    var qtyInput = $('[data-qty-input]', productSection);
    on($('[data-qty-decrease]', productSection), 'click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
    });
    on($('[data-qty-increase]', productSection), 'click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  /* ---------- Sticky mobile add-to-cart bar ---------- */
  var stickyBar = $('[data-sticky-add-bar]');
  var mainCta = $('[data-add-to-cart]');
  if (stickyBar && mainCta && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80px 0px' }).observe(mainCta);

    on($('[data-sticky-add]', stickyBar), 'click', function () { mainCta.click(); });
  }

  /* ---------- Collection filters (mobile drawer) ---------- */
  var filtersPanel = $('[data-filters-panel]');
  on($('[data-filters-toggle]'), 'click', function () {
    if (filtersPanel) filtersPanel.classList.toggle('is-open');
  });
  on($('[data-filters-close]'), 'click', function () {
    if (filtersPanel) filtersPanel.classList.remove('is-open');
  });

  /* ---------- Wishlist (localStorage only — no account sync yet) ---------- */
  var WISHLIST_KEY = 'inara:wishlist';

  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }

  function paintWishlist() {
    var saved = readWishlist();
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', saved.indexOf(btn.dataset.productHandle) !== -1);
    });
  }

  $$('[data-wishlist-toggle]').forEach(function (btn) {
    on(btn, 'click', function (e) {
      e.preventDefault();
      var handle = btn.dataset.productHandle;
      var saved = readWishlist();
      var i = saved.indexOf(handle);
      if (i === -1) saved.push(handle); else saved.splice(i, 1);
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(saved));
      paintWishlist();
    });
  });
  paintWishlist();

  /* ---------- Scroll reveal ---------- */
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealTargets = $$('[data-reveal]');

  if (prefersReduced || !('IntersectionObserver' in window)) {
    revealTargets.forEach(function (el) { el.classList.add('is-revealed'); });
  } else {
    var revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    revealTargets.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- Account: password recovery toggle ---------- */
  var recoverToggle = $('[data-recover-toggle]');
  var recoverForm = $('[data-recover-form]');

  if (recoverToggle && recoverForm) {
    recoverToggle.addEventListener('click', function (e) {
      e.preventDefault();
      recoverForm.classList.add('is-visible');
      var input = recoverForm.querySelector('input[type="email"]');
      if (input) input.focus();
    });

    // Shopify appends #recover after a failed/submitted recovery attempt
    if (window.location.hash === '#recover') {
      recoverForm.classList.add('is-visible');
    }
  }

  /* ---------- Account: confirm address deletion ---------- */
  $$('[data-address-delete]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var message = link.getAttribute('data-confirm-message') || 'Delete this address?';
      if (!window.confirm(message)) e.preventDefault();
    });
  });
})();
